import { FC } from "react";
import ArrowNavBackIcon from '@assets/svg/button-icons/arrow-nav-back-icon.svg?react'
import IconButton from '@mui/material/IconButton'
import s from './styles.module.css'

interface NavigationPanelProps {
	text: string,
	handleClick: () => void
}

const NavigationPanel: FC<NavigationPanelProps> = ({text, handleClick}) => {
  return (
		<nav className={s.wrapper}>
			<IconButton size="large" sx={{padding: '12px 20px'}} onClick={handleClick}>
				<ArrowNavBackIcon />
			</IconButton>
			<p className={s.text}>{text}</p>
		</nav>
	)
}

export default NavigationPanel